import { render, staticRenderFns } from "./ShortcutGroupsTableV2.vue?vue&type=template&id=2fe14f13&scoped=true"
import script from "./ShortcutGroupsTableV2.vue?vue&type=script&lang=js"
export * from "./ShortcutGroupsTableV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe14f13",
  null
  
)

export default component.exports